module.exports = __webpack_public_path__ + "static/case01-a698da6a1c683e14db47ad957b1b5776.jpg";